import React from 'react';

export function SettingsPanel({ children, title, subtitle, right }) {
  return (
    <section className="bg-white dark:bg-pine-900 border border-[var(--border)] rounded-xl overflow-hidden">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-4 py-3 border-b border-[var(--border)]">
        <div>
          <div className="text-[14px] font-black text-[var(--text)]">{title}</div>
          {subtitle && <div className="mt-0.5 text-[11px] font-semibold text-[var(--text-muted)]">{subtitle}</div>}
        </div>
        {right}
      </div>
      {children}
    </section>
  );
}
